import script from "./DeptTag.vue?vue&type=script&setup=true&lang=js"
export * from "./DeptTag.vue?vue&type=script&setup=true&lang=js"

import "./DeptTag.vue?vue&type=style&index=0&id=3e7f357b&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e7f357b"]])

export default __exports__